// extracted by mini-css-extract-plugin
export default {"alert-provider":"alertProvider_alert-provider__MvsRF"};